<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div class="signup-popup partners-signuppop" id="signup-popup">
  <div class="signup-wrap d-md-flex" id="signup-wrap">
    <div class="signup-fields">
      <a (click)="closecomponent()" class="close-btn"><i class="icon-close"></i></a>
      <div class="popup-logo text-center">
        <a href="/"><img src="../../assets/images/logo.png" alt="logo"></a>
      </div>
      <h4 class="signup-title text-center">Sign Up</h4>
      <p class="signup-info">Please complete the following information so we may determine if we are a mutually good
        fit. We will review your application and respond within 3-5 business days. For independent practitioners, we may
        request proof of certifications if your application is approved.
      </p>
      <div class="invalid-feedback text-center" style="display: block; margin-bottom:5px;position: static;"
        *ngIf="errorMessageEmail.length>0">{{errorMessageEmail}}</div>
      <form class="login-form" [formGroup]="registerFormPartener" (ngSubmit)="onSubmitPartenerFrom()">
        <div class="field-grp d-flex justify-content-between flex-wrap">
          <div class="form-group">
            <label class="form-label" for="title">Title*</label>
            <select class="form-control" id="title" formControlName="title"
              [ngClass]="{ 'is-invalid': submitted && formData.title.errors }">
              <!-- <option value="">select option</option> -->
              <option value="Mr." selected>Mr.</option>
              <option value="Mrs.">Mrs.</option>
              <option value="Ms.">Ms.</option>
              <option value="Dr.">Dr.</option>
            </select>
            <div *ngIf="submitted && formData.title.errors" class="invalid-feedback">
              <div *ngIf="formData.title.errors.required">Title Name is required</div>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label" for="fname">First Name*</label>
            <input class="form-control" id="fname" formControlName="firstName" type="text" placeholder="First Name*"
              [ngClass]="{ 'is-invalid': submitted && formData.firstName.errors }"
              onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>

            <div *ngIf="submitted && formData.firstName.errors" class="invalid-feedback">
              <div *ngIf="formData.firstName.errors.required">Please enter your first name</div>
            </div>
          </div>
        </div>
        <div class="field-grp d-flex justify-content-between flex-wrap">
          <div class="form-group">
            <label class="form-label" for="lname">Last Name*</label>
            <input class="form-control" id="lname" type="text" formControlName="lastName" placeholder="Last Name*"
              [ngClass]="{ 'is-invalid': submitted && formData.lastName.errors }"
              onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>

            <div *ngIf="submitted && formData.lastName.errors" class="invalid-feedback">
              <div *ngIf="formData.lastName.errors.required">Please enter your last name</div>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label" for="lname">Company*</label>
            <input class="form-control" id="Company" type="text" formControlName="companyName" placeholder="Company*"
              [ngClass]="{ 'is-invalid': submitted && formData.companyName.errors }"
              onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>

            <div *ngIf="submitted && formData.companyName.errors" class="invalid-feedback">
              <div *ngIf="formData.companyName.errors.required">Company Name is required</div>
            </div>
          </div>

        </div>
        <div class="field-grp d-flex justify-content-between flex-wrap">
          <div class="form-group">
            <label class="form-label" for="pos">Position*</label>
            <input class="form-control" id="pos" type="text" formControlName="position" placeholder="Position*"
              [ngClass]="{ 'is-invalid': submitted && formData.position.errors }"
              onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>

            <div *ngIf="submitted && formData.position.errors" class="invalid-feedback">
              <div *ngIf="formData.position.errors.required">Position Name is required</div>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label" for="email">Email Address*</label>
            <input class="form-control" id="email" type="text" formControlName="email" placeholder="Email Address*"
              [ngClass]="{ 'is-invalid': submitted && formData.email.errors }"
              onkeypress='return (event.which > 47 && event.which <= 57) || (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46 || event.which == 64'>

            <div *ngIf="submitted && formData.email.errors" class="invalid-feedback">
              <div *ngIf="formData.email.errors.required">Email is required</div>
              <div *ngIf="formData.email.errors.email">Email must be a valid email address</div>
              <div *ngIf="formData.email.errors.pattern">The email address must contain at least the @ character</div>
            </div>

          </div>

        </div>
        <div class="field-grp d-flex justify-content-between flex-wrap">
          <div class="form-group">
            <label class="form-label" for="mobileno">Mobile No*</label>
            <input class="form-control" id="mobileno" type="text" formControlName="mobile" maxlength="10"
              placeholder="Mobile No*" [ngClass]="{ 'is-invalid': submitted && formData.mobile.errors }"
              onkeypress='return (event.which > 47 && event.which <= 57) || event.which == 8 || event.which == 46'>

            <div *ngIf="submitted && formData.mobile.errors" class="invalid-feedback">
              <div *ngIf="formData.mobile.errors.required">Mobile No is required</div>
              <div *ngIf="formData.mobile.errors.minlength && formData.mobile.errors.maxlength">Number
                must be at least
                10 characters</div>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label" for="website">Website*</label>
            <input class="form-control" id="website" type="text" formControlName="website" placeholder="Website*"
              [ngClass]="{ 'is-invalid': submitted && formData.website.errors }">

            <div *ngIf="submitted && formData.lastName.errors" class="invalid-feedback">
              <div *ngIf="formData.website.errors.pattern">Website URL must be valid
              </div>
              <div *ngIf="formData.website.errors.required">Website is required</div>
            </div>
          </div>

        </div>
        <div class="field-grp d-flex justify-content-between flex-wrap">
          <div class="form-group">
            <label class="form-label" for="category">Category(s)*</label>
            <ng-multiselect-dropdown formControlName="categories"
              [ngClass]="{ 'is-invalid': submitted && formData.categories.errors }" [placeholder]="'Pick Any Top 3'"
              [settings]="dropdownSettings" [data]="dropdownList" [(ngModel)]="selectedCategories"
              (onSelect)="onItemSelect($event)">
            </ng-multiselect-dropdown>
            <div *ngIf="submitted && formData.firstName.errors" class="invalid-feedback">
              <div *ngIf="formData.firstName.errors.required">Category is required</div>
            </div>
          </div>
          <div class="form-group">
            <div class="upload-btn-wrapper">
              <label class="form-label">Profile Image</label>
              <label class="upl-btn form-control" for="profile-image">
                {{upfilename !== ''? upfilename: 'Upload a file'}}
              </label>
              <input type="file" class="uploader_career" id="profile-image" #registerProfilePartenerImage
                (change)="getFile2($event)" />
            </div>

          </div>
          <span *ngIf="fileUploadImageSrcVendor" style="margin: 0 auto;">
            <img [src]="fileUploadImageSrcVendor">
          </span>

        </div>
        <div class="field-grp d-flex justify-content-between flex-wrap">
          <p _ngcontent-ogx-c71="" class="signup-terms">By signing up, I agree to MyLifeWell <a _ngcontent-ogx-c71=""
              href="/terms-conditions">Terms of Service</a>,

            and <a _ngcontent-ogx-c71="" href="/privacy_policy">Privacy</a>. </p>
          <div *ngIf="submitted && formData.termsofservice.errors" class="invalid-feedback" style="position: static">
            <div *ngIf="formData.termsofservice.errors.required">Please check before submitting details</div>
          </div>
        </div>
        <div class="buttons-wrap">
          <button class="btn">Sign Up</button>
        </div>
        <p class="already-signup">Already a MyLifeWell.com member? <a [href]="globalurl + 'vendors'" target="_blank">Log
            In</a> </p>
      </form>
    </div>
  </div>
  <div *ngIf="resMsg && resMsg.length > 0">
    <h2 [innerHTML]="resMsg" class="success"> </h2>
  </div>
</div>
<div class="enquiry-poup">
  <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
  </app-modal-pop-up>
</div>